import React, { useEffect } from 'react';
import './TransferPage.css';
import config from '../config/config';
import { useDocTitle } from '../hooks/CustomHook';

const TransferPage = () => {
    useDocTitle('族语APP家族邀请');
    // 链接保持不变（请替换成真实链接）
    const iosLink = 'https://apps.apple.com/us/app/族语/id6751788359';
    const xiaomiLink = 'http://app.mi.com/details?id=com.zuyu.app';
    const vivoLink = 'https://h5coml.vivo.com.cn/h5coml/appdetail_h5/browser_v2/index.html?appId=4449732';
    const oppoLink = 'https://www.opposhop.cn/products/YOUR_APP_ID';
    const honorLink = 'https://www.hihonor.com/cn/apps/YOUR_APP_ID';
    const iosScheme = 'zuyuapp://open?data=liuchengzuishuai';

    const backgroundImage = config.inviteBgUrl;
    const appStoreLogo = config.iosIconUrl;
    const androidMarketLogo = config.andoridIconUrl;
    const rectangleIconUrl = config.rectangleIconUrl;

    useEffect(() => {
        const ua = navigator.userAgent.toLowerCase();
        console.log('User Agent:', ua);
        alert(ua);
        //初始化的时候跳转至app/默认跳转应用市场
        if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) {
            //IOS 设备
            // handleDownload('ios');
        }
        else {
            //安卓设备
            // handleDownload('android');
        }
    }, []);

    const handleDownload = (type) => {
        switch (type) {
            case 'ios':
                handleIosDownload();
                break;
            case 'android':
                handleAndroidDownload();
                break;
            default:
                break;
        }
    }

    const handleIosDownload = () => {
        let timer = null;
        const timeoutDuration = 2500;

        const clearTimer = () => {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
        };

        window.addEventListener('pagehide', clearTimer, { once: true });
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden' || document.hidden) {
                clearTimer();
            }
        }, { once: true });
        window.onblur = clearTimer;

        timer = setTimeout(() => {
            clearTimer();
            window.location.href = iosLink;
        }, timeoutDuration);

        window.location.href = iosScheme;
    };

    const handleAndroidDownload = () => {
        const ua = navigator.userAgent.toLowerCase();
        let targetLink = xiaomiLink;

        if (ua.includes('xiaomi') || ua.includes('miui') || ua.includes('redmi')) {
            alert('xiaomi');
            targetLink = xiaomiLink;
        }
        else if (ua.includes('vivo')) {
            alert('vivo');
            targetLink = vivoLink;
        }
        else if (ua.includes('oppo') || ua.includes('coloros') || ua.includes('realme')) {
            alert('oppo');
            targetLink = oppoLink;
        }
        else if (ua.includes('honor') || ua.includes('magic')) {
            alert('honor');
            targetLink = honorLink;
        }

        window.location.href = targetLink;
    };

    return (
        <div className="download-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className="container">
                <div className="text-wrapper">
                    <div className="title">您的家人正邀请您一起</div>
                    <div className="title">完善家的记忆</div>
                </div>
                <div
                    className="rectangle-spacer"
                    style={{
                        backgroundImage: `url(${rectangleIconUrl})`,
                    }}
                />
                <div>
                    <div className="content">您的亲人期待得到您的帮助，别让亲情缺</div>
                    <div className="content">席，成为无法弥补的遗憾。</div>
                </div>
            </div>
            <div className="buttons-wrapper">
                <button className="store-button" onClick={() => handleDownload('ios')}>
                    <img src={appStoreLogo} alt="App Store" />
                </button>

                <button className="store-button" onClick={() => handleDownload('android')}>
                    <img src={androidMarketLogo} alt="Android Market" />
                </button>
            </div>
        </div>
    );
};

export default TransferPage;